import React from 'react';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Dropdown, DropdownToggle } from 'reactstrap';
import styled from 'styled-components';
import { selectMyProfile } from '../../../store/Account/selectors';
import { LoginModalMode } from '../../Registration/login-enum';
import LoginRegisterDialog from '../../Registration/login-register-dialog';
import ReportMapContent from './report-map-content';
import ReportMapMenu from './report-map-menu';

const ReportMap = () => {
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
    const [showLogin, setShowLogin] = useState<boolean>(false);
    const toggleRef = useRef<HTMLInputElement>(null);

    const myProfile = useSelector(selectMyProfile);

    const handleReportImage = () => {
        if (!myProfile) {
            setShowLogin(true);
            return;
        }
        setDropdownOpen(!dropdownOpen);
    };

    return (
        <React.Fragment>
            <ReportMapDropdown
                direction="right"
                onClick={(e) => e.stopPropagation()}
                isOpen={dropdownOpen}
                toggle={handleReportImage}
            >
                <ReportToggle tag="span" id="report-map-toggle">
                    <ReportEllipsisIcon className={'fa fa-ellipsis-h'} ref={toggleRef} />
                </ReportToggle>

                {dropdownOpen && toggleRef?.current ? (
                    <React.Fragment>
                        <ReportMapMenu toggleRef={toggleRef.current}>
                            <ReportMapContent handleReportIsOpen={() => setDropdownOpen(!dropdownOpen)} />
                        </ReportMapMenu>
                    </React.Fragment>
                ) : null}
            </ReportMapDropdown>
            {showLogin && (
                <LoginRegisterDialog
                    isOpen={true}
                    initialMode={LoginModalMode.LOGIN}
                    onClose={() => setShowLogin(false)}
                />
            )}
        </React.Fragment>
    );
};

export default ReportMap;

const ReportMapDropdown = styled(Dropdown)``;

const ReportToggle = styled(DropdownToggle)`
    color: white;
    width: 50px;

    &:hover {
        color: #eed926;
    }

    &:after {
        display: block;
    }
`;

const ReportEllipsisIcon = styled.i`
    font-size: 16px;
    color: rgba(255, 255, 255, 0.87);
    margin-top: 20px;
    padding: 5px 8px 0px 0px;
    cursor: pointer;
`;
